import { NextSeo, ArticleJsonLd } from "next-seo";
import { SEO } from "@/constants/index";
import { PUBLISHER_LOGO } from "@/constants/seo";
import { Article } from "@/graphql/gql/graphql";

const ArticleSeo = ({ article }: { article: Article }) => {
  const { title, seo, thumbnailImageUrl, slug, hero } = article;

  const url = `${SEO.FANDUEL_URL_RESEARCH}/${slug}`;
  const openGraphTitle = seo?.openGraphTag?.title ?? title;
  const image =
    seo?.openGraphTag?.image?.url ??
    hero?.imageUrl?.url ??
    thumbnailImageUrl?.url;
  const images = image
    ? {
        images: [
          {
            width: 800,
            height: 600,
            alt: "Og Image Alt",
            type: "image/jpeg",
            url: image,
          },
        ],
      }
    : {};
  return (
    <>
      <NextSeo
        title={seo?.title ?? title}
        description={seo?.description ?? ""}
        canonical={seo?.canonicalUrl ?? url}
        noindex={!!seo.noIndex}
        openGraph={{
          title: openGraphTitle,
          url,
          description: seo?.description ?? "",
          ...images,
          type: "article",
          article: {
            publishedTime: article.firstPublishedAt ?? new Date().toISOString(),
          },
        }}
        twitter={{
          cardType: "summary_large_image",
        }}
      />
      <ArticleJsonLd
        useAppDir={false}
        url={`https://www.fanduel.com/research/${article.slug}`}
        title={seo?.title ?? title}
        description={seo?.description ?? ""}
        images={[image || ""]}
        datePublished={article.firstPublishedAt ?? new Date().toISOString()}
        dateModified={article.lastPublishedAt ?? undefined}
        authorName={[
          {
            name: article.author.name,
            url: article.author.socialMedia?.[0]?.url,
          },
        ]}
        publisherName="FanDuel Research"
        publisherLogo={PUBLISHER_LOGO}
        isAccessibleForFree
      />
    </>
  );
};

export default ArticleSeo;
